interface Config {
    isLocalDevelopment?: boolean;
    buildMode: 'dev' | 'prod' | 'beta';
    apiBaseUrl: string;
}

let config: Config;
let buildMode: 'dev' | 'prod' | 'beta';
if (import.meta.env.MODE === 'development') {
    buildMode = 'dev';
} else if (import.meta.env.MODE === 'production') {
    buildMode = 'prod';
} else {
    buildMode = 'beta';
}

/**
 * 관리자 / 핏플러스 인앱 웹뷰 페이지 도메인에 따라 다른 API URL 반환
 * @param hostname 도메인
 * @returns API URL
 */
function getApiBaseUrlByHost(hostname: string) {
    // 관리자 페이지 분기
    // 구조상 admin 아래의 모든 .env 파일에 아래 변수가 있어야 함
    if (hostname.endsWith('admin.beta.inbody.dev')) {
        return import.meta.env.VITE_API_URL_FITPLUSKR_BETA;
    } else if (hostname.endsWith('admin.inbody.dev')) {
        return import.meta.env.VITE_API_URL_FITPLUSKR_ADMIN;
    } else if (hostname.endsWith('admin.test.inbody.dev')) {
        return import.meta.env.VITE_API_URL_FITPLUSKR_TEST;
    }
    // 핏플러스 인앱 웹뷰 페이지 분기
    else if (hostname.endsWith('webview.beta.inbody.dev')) {
        return import.meta.env.VITE_API_URL_FITPLUSKR_BETA;
    } else if (hostname.endsWith('webview.inbody.dev')) {
        return import.meta.env.VITE_API_URL_FITPLUSKR_PROD;
    } else if (hostname.endsWith('webview.test.inbody.dev')) {
        return import.meta.env.VITE_API_URL_FITPLUSKR_TEST;
    } else {
        // 기본 값
        // 관리자, 핏플러스 인앱의 경우 VITE_API_URL_FITPLUSKR는 test url
        // 그 외 도메인일 경우 buildMode에 따라 각 .env 파일에 저장된 VITE_API_URL_FITPLUSKR url
        return import.meta.env.VITE_API_URL_FITPLUSKR;
    }
}

config = {
    buildMode: buildMode,
    apiBaseUrl: getApiBaseUrlByHost(window.location.hostname),
};

// 개발 시 로컬 개발 환경 플래그 활성화
config.isLocalDevelopment = false;

export default config;
